export enum UserRole {
  Admin = 'admin',
  TenantUser = 'tenant_user',
  TenantAdmin = 'tenant_admin',
}

export enum CourseStepStatus {
  Locked = 'locked',
  Active = 'Active',
  Completed = 'completed',
}

export enum JourneyStage {
  PRE_TRAINING = 'PreTraining',
  GUIDELINES = 'Guidelines',
  NAVIGATING_DECISIONS = 'NavigatingDecisions',
  PATIENT_OUTCOMES = 'PatientOutcomes',
  PATIENT_RISKS = 'PatientRisks',
  PATIENT_EXPECTATIONS = 'PatientExpectations',
  PROVIDER_DISCUSSIONS = 'ProviderDiscussions',
  POST_TRAINING = 'PostTraining',
}

export enum PatientJourneyStage {
  PRE_COURSE = 'Patients Pre-Course',
  INTRODUCTION = 'Patients Introduction',
  BEFORE_SURGERY = 'Before Surgery',
  DAY_OF_SURGERY = 'Day of Surgery',
  AFTER_SURGERY = 'After Surgery',
  DAYS_AFTER_SURGERY = 'Days After Surgery',
  ENHANCED_RECOVERY_JOURNEY = 'Enhanced Recovery Journey (ERP)',
  POST_COURSE = 'Patients Post-Course',
}

export enum ProviderJourneyStage {
  PRE_COURSE = 'Providers Pre-Course',
  INTRODUCTION = 'Providers Introduction',
  PREADMISSION = 'Preadmission',
  PREOPERATIVE = 'Preoperative',
  INTRAOPERATIVE = 'Intraoperative',
  POSTOPERATIVE = 'Postoperative',
  ERP_WORKFLOW = 'ERP Workflow',
  POST_COURSE = 'Providers Post-Course',
}

export enum CourseSubmissionStatus {
  ACTIVE = 'active',
  OUTDATED = 'outdated',
  COMPLETED = 'completed',
  DISCARDED = 'discarded',
}

export enum VerifyCodeType {
  Email = 'email',
  Phone = 'phone',
}

export enum TranslationState {
  NONE = 'none',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  OUTDATED = 'outdated',
  COMPLETED = 'completed',
}

export enum ResourceItemType {
  LINK = 'link',
  VIDEO = 'video',
  REFERENCE = 'reference',
  TITLE_LINK = 'title_link',
  REFERENCE_TEXT = 'reference_text',
}
